import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "divSurgeDisplay"
}
const _hoisted_2 = {
  class: "container-fluid surgeStrip dashboardSurgeHeight",
  id: "dvMainSurgeUL"
}
const _hoisted_3 = { id: "SurgeUL" }
const _hoisted_4 = {
  class: "navSurge",
  id: "surgeDiv"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { id: "lblSurge" }, "SURGE", -1)
const _hoisted_6 = {
  class: "navSurge",
  id: "firstLI"
}
const _hoisted_7 = {
  class: "navSurge",
  id: "lastLI"
}
const _hoisted_8 = {
  rowspan: "2",
  style: {"font-size":"1rem !important","padding-right":"10px"}
}
const _hoisted_9 = { id: "lblLastUpdated" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "2",
  style: {"font-size":"1rem !important","padding-right":"12px"}
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0)",
  id: "linkSurgeDetailsDisplay"
}, "Settings", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['navSurge'])
}
const _hoisted_14 = { class: "liSurge" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", { class: "popoverline" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", { class: "popoverline" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_container = _resolveComponent("neu-container")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_neu_tooltip = _resolveComponent("neu-tooltip")!

  return (_ctx.surgeDisplayValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_font_awesome_icon, {
                id: "warningIco",
                icon: ['fas', 'exclamation-triangle'],
                size: "lg"
              })
            ]),
            _createElementVNode("li", _hoisted_6, [
              _withDirectives(_createVNode(_component_font_awesome_icon, {
                title: "Previous",
                icon: ['fas', 'angle-left'],
                size: "1x",
                style: {"cursor":"pointer","padding-top":"4px"},
                id: "btnsurgeprv",
                onClick: _ctx.surgePrev
              }, null, 8, ["onClick"]), [
                [_vShow, _ctx.isShowSurgePrev]
              ])
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("table", null, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_8, [
                      _withDirectives(_createVNode(_component_font_awesome_icon, {
                        title: "Next",
                        class: "navSurge",
                        icon: ['fas', 'angle-right'],
                        size: "1x",
                        style: {"cursor":"pointer"},
                        id: "btnsurgenext",
                        onClick: _ctx.surgeNext
                      }, null, 8, ["onClick"]), [
                        [_vShow, _ctx.isShowSurgeNext]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("label", _hoisted_9, " Last Updated: " + _toDisplayString(_ctx.getCurrentDate()), 1)
                    ]),
                    _hoisted_10,
                    _createElementVNode("td", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showUserPreferencesPopup && _ctx.showUserPreferencesPopup(...args)))
                    }, _hoisted_12)
                  ])
                ])
              ])
            ]),
            (_ctx.isShowSurgeAlertData)
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surgeAlertDisplayDataList, (item) => {
                    return (_openBlock(), _createBlock(_component_neu_tooltip, {
                      class: "tooltipRight",
                      key: item
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_neu_container, {
                          slot: "content",
                          id: item.DepteId,
                          "data-facilityCode": item.FacilityShortName,
                          "data-DeptName": item.DepartmentName,
                          class: _normalizeClass(['spnIconPopover dashboardSurgeitemHeight',
                                item.EdwinScoreColor == 'Yellow' ? 'bgClrYellow' : '',
                                item.EdwinScoreColor == 'Red' ? 'bgClrRed' : ''])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(item.FacilityShortName.substr(0, 3) + ' ' + item.TotalSecondsInSurge), 1)
                          ]),
                          _: 2
                        }, 1032, ["id", "data-facilityCode", "data-DeptName", "class"]),
                        _createVNode(_component_neu_container, { slot: "tooltip" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_neu_row, {
                              class: "headlabel",
                              leftAlig: "",
                              xxl: "3",
                              xl: "6",
                              lg: "12",
                              md: "3",
                              sm: "6",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.SurgePopOverDataByDept.facilityName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_neu_row, {
                              class: "popoverSubHeadtext",
                              leftAlig: "",
                              xxl: "3",
                              xl: "6",
                              lg: "12",
                              md: "3",
                              sm: "6",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.SurgePopOverDataByDept.departmentName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _hoisted_15,
                            _createVNode(_component_neu_row, {
                              xxl: "3",
                              xl: "6",
                              lg: "12",
                              md: "3",
                              sm: "6",
                              cols: "12",
                              class: "row leftAlign"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_neu_col, {
                                  leftAlig: "",
                                  xxl: "3",
                                  xl: "6",
                                  lg: "12",
                                  md: "3",
                                  sm: "6",
                                  cols: "12",
                                  class: "col-sm-9 popovertext colRight"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Current EDWIN Score:")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_neu_col, {
                                  rightAlig: "",
                                  xxl: "3",
                                  xl: "6",
                                  lg: "12",
                                  md: "3",
                                  sm: "6",
                                  cols: "12",
                                  class: "col-sm-3 valuesText popovertext"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(item.SurgePopOverDataByDept.boxclass)
                                    }, null, 2),
                                    _createTextVNode(" " + _toDisplayString(item.SurgePopOverDataByDept.currentEdwinScore), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_neu_row, { class: "row leftAlign" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_neu_col, { class: "col-sm-9 popovertext colRight" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Time in Current State:")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_neu_col, { class: "col-sm-3 valuesText popovertext" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.SurgePopOverDataByDept.timeInCurrentState), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_neu_row, { class: "row leftAlign" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_neu_col, { class: "col-sm-9 popovertext colRight" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Total Time in Surge:")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_neu_col, { class: "col-sm-3 valuesText popovertext" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.SurgePopOverDataByDept.totalTimeInSurge), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _hoisted_16,
                            _createVNode(_component_neu_row, { class: "row leftAlign" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_neu_col, { class: "col-sm-9 popovertext colRight" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Volume Since Midnight:")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_neu_col, { class: "col-sm-3 valuesText popovertext" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.SurgePopOverDataByDept.volumeSinceMidnight), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_neu_row, { class: "row leftAlign" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_neu_col, { class: "col-sm-9 popovertext colRight" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Actual Census:")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_neu_col, { class: "col-sm-3 valuesText popovertext" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.SurgePopOverDataByDept.actualCensus), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}